<template>
    <div>
    </div>
</template>

<style scoped>

</style>

<script>
export default {
    components: {

    },
    data() {
        return {

        }
    },
    computed: {

    },
    methods: {
        onSuccess(position) {
            console.log('new position detected', position)
            this.$store.dispatch('setGPS', position.coords)
            this.$root.$emit('validGPS')
        },
        onError(err) {
            console.log('error2', err)
            this.$store.dispatch('setGPS', {
                latitude: 0,
                longitude: 0
            })
            this.$root.$emit('invalidGPS')
        }
    },
    mounted() {
        console.log('mounted from LocationTracker')
        navigator.geolocation.getCurrentPosition(
            position => {
                console.log('position', position)
                this.onSuccess(position)
            },
            error => {
                console.log('error1', error.message)
                /*
                var payload = {
                    latitude: 14.5905,
                    longitude: 120.9779
                }
                this.$store.dispatch('setGPS', payload)
                */
               alert('Gozhere requires GPS for finding near you places')
               this.onError(error)
            }
        )
        var watchOptions = {
            timeout : 60*60*1000,
            maxAge: 0,
            enableHighAccuracy: true
        }
        navigator.geolocation.watchPosition(this.onSuccess, this.onError, watchOptions)
    }
}
</script>